var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#513764;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2187",
    className: "st0",
    d: "M30,0h40c16.6,0,30,13.4,30,30v70l0,0H30C13.4,100,0,86.6,0,70V30C0,13.4,13.4,0,30,0z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.4,57.2l23.2-6.8c1.4-0.4,2.7,0.9,2.3,2.3l-6.8,23.2c-0.5,1.6-2.6,1.8-3.4,0.3l-3.3-6.5 c-0.1-0.1-0.2-0.3-0.3-0.4l-10,10c-1.4,1.4-3.7,1.4-5.1,0s-1.4-3.7,0-5.1l10-10c-0.1-0.1-0.3-0.2-0.4-0.3l-6.5-3.2 C26.7,59.8,26.8,57.7,28.4,57.2z M53,73c12,0,21.7-9.7,21.7-21.8S65,29.5,53,29.5c-12,0-21.8,9.7-21.8,21.8c0,0.4,0,0.9,0,1.3 l-7.1,2.1c-0.1-1.1-0.2-2.3-0.2-3.4c0-16,13-29,29-29s29,13,29,29s-13,29-29,29c-1.2,0-2.3-0.1-3.4-0.2l2.1-7.1 C52.1,73,52.6,73,53,73z M53.3,67.6l2.2-7.6c3.8-1.1,6.6-4.6,6.6-8.7c0-5-4.1-9.1-9.1-9.1c-4.1,0-7.6,2.8-8.7,6.6L36.7,51 c0.1-8.9,7.4-16.1,16.3-16.1c9,0,16.3,7.3,16.3,16.3C69.3,60.2,62.2,67.4,53.3,67.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsPurple);
export default __webpack_public_path__ + "static/media/Analytics_Purple.dc34c39303cd15f0bc55387b1d1aae24.svg";
export { ForwardRef as ReactComponent };